import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'src/features/auth/authSlice';

/**
 * Hook to check if a user feature is enabled for the current user
 * @param featureCode - The feature code to check (e.g., 'dev_dashboard_access')
 * @returns boolean indicating if the feature is enabled
 */
export const useUserFeature = (featureCode: string): boolean => {
  const user = useSelector(authSelectors.user);

  if (!user?.user_features) {
    return false;
  }

  return user.user_features.includes(featureCode);
};

export default useUserFeature;
